import { FieldName, PromptType } from 'src/sections/chat-gpt/Form/Form.types';
import { BLISS_GATEWAY_ROOT_URL } from '@utils/urlHelpers.util';

type ChatGptApiPayload = {
  promptType: PromptType;
  payloadStrings: {
    key: FieldName;
    value: string;
  }[];
};

export const useChatGptApiRequest = () => {
  const url = BLISS_GATEWAY_ROOT_URL + '/graphql';

  const fetchData = async (variables: ChatGptApiPayload) => {
    const query = {
      query: `
        query WRITERSBLOCK($promptType: PromptType!, $payloadStrings: [PayloadStrings!]!) {
          textCompletionV2(promptType: $promptType, payloadStrings: $payloadStrings)
        }
      `,
      operationName: 'WRITERSBLOCK',
      variables,
    };

    let options = {
      method: 'POST',
      headers: {
        'Accept-Encoding': 'gzip, deflate, br',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Connection: 'keep-alive',
        DNT: '1',
        Origin: BLISS_GATEWAY_ROOT_URL,
      },
      body: JSON.stringify(query),
    };

    const res = await fetch(url, options);
    return await res.json();
  };

  return {
    fetchData,
  };
};
